import { render, staticRenderFns } from "./standburg.vue?vue&type=template&id=4553008e&scoped=true"
import script from "./standburg.vue?vue&type=script&lang=js"
export * from "./standburg.vue?vue&type=script&lang=js"
import style0 from "./standburg.vue?vue&type=style&index=0&id=4553008e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553008e",
  null
  
)

export default component.exports